
import { req } from './axiosFun';

// 交易订单-获取交易订单列表
export const OrderList = (params) => { return req("post", "/api/front/order/infoAdmin", params) };

// 订单反馈
export const FeedbackList = (params) => { return req("post", "/api/front/feedback/admin/getFeedBack", params) };

// 更新反馈
export const FeedbackUpdate = (params) => { return req('put', '/api/front/feedback/putFeedBack?id=' + params + "&" + 'status=已处理') };

// 回复

export const FeedbackReply = (params) => { return req("post", "/api/front/feedback/admin/mail", params) };

// 图
// 一星期流水
export const weekTotalCount = () => { return req("get", "/api/front/count/weekTotalCount") };

// 一星期积分变化

export const weekScoreCount = () => { return req("get", "/api/front/count/weekSumCount") };


// WEBPACK FOOTER //
// ./src/api/payMG.js